import React from 'react';
import ConfLoader from '@rwc/components/conf-loader';

export function PlaceholderLoader() {
    const isShowLoading = window.location.pathname.includes('/conf/on/');
    return isShowLoading ? <ConfLoader /> : null;
}
